export const SERVICE_CODE = 'TRAINING_PRODUCT_ORIGIN' + '_SERVICE';
